import { createAsyncThunk } from '@reduxjs/toolkit';
import translation from 'translation';
import { apiGet, apiPost, apiRemove } from 'api-service';
import { magicNumbers } from 'utils';
import { isEmpty, toast } from 'lib';
import { toggleSupportMenu } from './pageSlice';

const { t } = translation;

export const fetchQueries = createAsyncThunk(
  'pageReducer/fetchQueries',
  async (_, thunkAPI) => {
    const response = await apiGet('/search/queries', {
      no_paginate: 1,
      orderBy: [{ field: 'created_at', type: 'desc' }],
      per_page: undefined,
    });
    const { currentQuery } = thunkAPI.getState().pageReducer;
    const { freeSearch, megaSubject } =
      thunkAPI.getState().accountReducer.currentUser.user.permissions.FrontEnd;
    const queries = response.data.result.data;
    if (freeSearch.permission && megaSubject.permission) {
      queries.unshift({
        id: magicNumbers.MEGA_SUBJECT_QUERY_ID,
        parsed_query: '',
        title: t('common:metaSubject'),
      });
    }
    if (
      freeSearch.permission &&
      (Boolean(currentQuery.q) || Boolean(currentQuery.lastSearchQuery))
    ) {
      queries.unshift({
        id: magicNumbers.YOUR_SEARCH_QUERY_ID,
        parsed_query: currentQuery.q ?? currentQuery.lastSearchQuery ?? '',
        title: t('common:search.yourSearch'),
      });
    }
    return queries.map((query) => ({
      ...query,
      parsed_query: !isEmpty(query.shared_source) ? '' : query.parsed_query,
    }));
  }
);

export const updateTrainingVideosSettings = createAsyncThunk(
  'pageReducer/updateTraningVideoSettings',
  async (params, thunkAPI) => {
    try {
      const response = await apiPost('/user/user-settings', {
        key: 'page_settings.training_videos',
        value: params,
      });
      return response.data?.result?.data?.value;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const fetchTrainingVideosSettings = createAsyncThunk(
  'pageReducer/fetchTraningVideoSettings',
  async ({ currentPageIsViewedField }, thunkAPI) => {
    try {
      const response = await apiGet('/user/user-settings', {
        key: 'page_settings.training_videos',
      });
      const trainingVideosSettings = response.data?.result?.data?.value || {};
      if (!trainingVideosSettings?.[currentPageIsViewedField]) {
        thunkAPI.dispatch(
          toggleSupportMenu({
            isVisible: true,
          })
        );
        await thunkAPI.dispatch(
          updateTrainingVideosSettings({
            [currentPageIsViewedField]: true,
          })
        );
      }
      return trainingVideosSettings;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getSearchHistory = createAsyncThunk(
  'pageReducer/getSearchHistory',
  async ({ searchType }, thunkAPI) => {
    try {
      const response = await apiGet('/search/api/v1/search/history', {
        search_type: searchType,
      });

      return response?.data?.result?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteSearchHistory = createAsyncThunk(
  'pageReducer/deleteSearchHistory',
  async ({ query }, thunkAPI) => {
    const url = '/search/api/v1/search/history';
    try {
      const response = await apiRemove(url, { query });

      return response?.data?.result?.data;
    } catch (error) {
      toast({
        type: 'error',
        title: t('common:errorOperation'),
        description: t('search:error.deleteSearchHistory.description'),
      });

      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteAllSearchHistory = createAsyncThunk(
  'pageReducer/deleteAllSearchHistory',
  async (_, thunkAPI) => {
    const url = '/search/api/v1/search/history/all';

    try {
      const response = await apiRemove(url);
      return response?.data?.result?.data;
    } catch (error) {
      toast({
        type: 'error',
        title: t('common:errorOperation'),
        description: t('search:error.deleteAllSearchHistory.description'),
      });
      return thunkAPI.rejectWithValue(error);
    }
  }
);
